import { useMemo } from 'react';
import { cx } from '@/utils';
import SvgCrossCircle from '@common/Icons/CrossCircle';

import { COLORS } from '@/utils/constants';

export type AlertNotificationType = 'ERROR' | 'WARNING';

type Props = {
  message: string;
  type: AlertNotificationType;
};

const AlertNotification = ({ message, type }: Props) => {
  const classname = useMemo(() => {
    switch (type) {
      case 'ERROR':
        return 'border border-solid border-redError bg-redLight';
    }
  }, [type]);

  const textStyles = useMemo(() => {
    switch (type) {
      case 'ERROR':
        return 'text-redError';
    }
  }, [type]);

  return (
    <div
      className={cx(
        'inline-flex min-h-[44px] w-full items-center justify-center gap-[10px] rounded-[3px] p-[10px_72px]',
        classname
      )}
    >
      <SvgCrossCircle width={24} height={24} color={COLORS.redError} />
      <div className={cx('body-text2', textStyles)}>{message}</div>
    </div>
  );
};

export default AlertNotification;
